// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Injects JSON into the Swagger UI 3 Try-it-out body editor for POST /premium.
 * Instruction used: scope-discipline.instructions.md
 */

export function applyJsonToPremiumTryItOut(jsonText) {
  const root = document.getElementById('swagger-ui-container')
  if (!root) {
    return { ok: false, reason: 'Swagger UI is not available.' }
  }

  const block = findPremiumPostBlock(root)
  if (!block) {
    return { ok: false, reason: 'POST /premium was not found.' }
  }

  if (!block.classList.contains('is-open')) {
    const summary = block.querySelector('.opblock-summary')
    if (summary) summary.click()
  }

  const tryBtn = block.querySelector('button.try-out__btn')
  if (tryBtn && /try it out/i.test((tryBtn.textContent || '').trim())) {
    tryBtn.click()
  }

  const textarea = block.querySelector('textarea.body-param__text') || block.querySelector('textarea')
  if (!textarea) {
    return { ok: false, reason: 'Request body editor was not found. Copy the JSON and paste it into Try it out.' }
  }

  setNativeTextareaValue(textarea, jsonText)
  return { ok: true }
}

function findPremiumPostBlock(root) {
  const operations = root.querySelectorAll('.opblock')
  for (let i = 0; i < operations.length; i++) {
    const el = operations[i]
    const method = el.querySelector('.opblock-summary-method')
    const path = el.querySelector('.opblock-summary-path')
    const methodText = method ? method.textContent.trim() : ''
    const pathText = path ? path.textContent.replace(/\s/g, '') : ''
    if (methodText === 'POST' && isPremiumPath(pathText)) {
      return el
    }
  }
  return null
}

function isPremiumPath(pathText) {
  if (!pathText || pathText.indexOf('lixi') !== -1) return false
  return pathText === '/premium' || /(^|\/)premium$/.test(pathText)
}

function setNativeTextareaValue(textarea, value) {
  const prototype = window.HTMLTextAreaElement && window.HTMLTextAreaElement.prototype
  const descriptor = prototype && Object.getOwnPropertyDescriptor(prototype, 'value')
  if (descriptor && descriptor.set) {
    descriptor.set.call(textarea, value)
  } else {
    textarea.value = value
  }
  textarea.dispatchEvent(new Event('input', { bubbles: true }))
  textarea.dispatchEvent(new Event('change', { bubbles: true }))
}
